import { useState, useCallback } from "react";

export type SortCondition = {
  field: string;
  order: "asc" | "desc";
};

const useSort = (initialSort?: SortCondition) => {
  const [sort, setSort] = useState<SortCondition | undefined>(initialSort);

  // Get the sort order for a specific field (useful for UI indicators)
  const getSortOrder = useCallback(
    (field: string): "ascend" | "descend" | undefined => {
      return sort?.field === field
        ? sort.order === "asc"
          ? "ascend"
          : "descend"
        : undefined;
    },
    [sort]
  );

  return {
    sort,
    setSort,
    getSortOrder,
  };
};

export default useSort;
